import debug from "debug";
import plugin from '../../lib/plugin';
import debounce from '../../lib/debounce';

const MODULE_NAME = 'app.core/modules/sync-value';
const log = debug(MODULE_NAME);

const ELEMENT_SELECTOR = '[data-sync-value]';

class SyncValue {
    constructor(element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        log('SyncValue', element, options);
        this.watch();
    }

    watch() {
        this.$element.on(
            'keyup.syncvalue',
            debounce(() => {
                SyncValue.$bus.publish('syncvalue', {
                    value: this.element.value
                });
            }, this.options.debounceMs)
        );

        SyncValue.$bus.subscribe('syncvalue', (event, { value = '' }) => {
            log('syncvalue', value);
            this.element.value = value;
        });

        log('bound', this.element);
    }

    unwatch() {
        this.$element.off('.syncvalue');
        log('unbound', this.element);
    }
}

SyncValue.DEFAULTS = {
    debounceMs: 50
};

plugin('syncValue', SyncValue);

export function exec() {
    $(document).ready(() => {
        log('binding');
        $(ELEMENT_SELECTOR).syncValue();
        log('bound');
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/sync-value/index.js